import React, { useEffect } from 'react';
import Popper, { PopperPlacementType } from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

interface NewEventOptionsProps {
  popperContent: React.ReactNode;
  bottomContent: React.ReactNode;
  filterSelected: any;
}

function NewEventOptionsPopper(props: NewEventOptionsProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [open, setOpen] = React.useState(false);
  const [placement] = React.useState<PopperPlacementType>('bottom-end');
  const [arrowRef, setArrowRef] = React.useState<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (props.filterSelected) {
      handleClickAway();
    }
  }, [props.filterSelected]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box sx={{ width: 500 }}>
        <div
          style={{ flex: 1 }}
          onClick={handleClickAway}
          tabIndex={0}
          role="button"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleClickAway();
            }
          }}
        ></div>
        <Popper
          sx={{ zIndex: 5 }}
          open={open}
          anchorEl={anchorEl}
          placement={placement}
          transition
          modifiers={[
            {
              name: 'arrow',
              enabled: true,
              options: {
                element: arrowRef,
              },
            },
          ]}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <Typography sx={{ 
                  display: 'flex',
                  alignItems: 'center', 
                  justifyContent: 'center',
                 width: '198px', 
                 height: '44px',
                 marginTop: '20px', 
                 borderRadius: '4px',
                 borderBottom: '1px solid var(--Line-divider, rgba(0, 39, 74, 0.15))',
                '&:hover': {
                  width: '198px',
                  height: '44px',
                  display: 'flex',
                  alignItems: 'center', 
                  justifyContent: 'center',
                  padding: 'none',
                  cursor: 'pointer',
    }, }}>{props.popperContent}</Typography>
              </Paper>
            </Fade>
          )}
        </Popper>
        <span
          ref={setArrowRef}
          className="bottom-target"
          onClick={handleClick}
          tabIndex={0}
          role="button"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleClick(event as unknown as React.MouseEvent<HTMLButtonElement>);
            }
          }}
        >
          {props.bottomContent}
        </span>
      </Box>
    </ClickAwayListener>
  );
}

export default NewEventOptionsPopper;